import React, { useState, useEffect } from "react";
import axios from "../../libs/axios";
import { Formik, Form } from "formik";
import TextField from "@mui/material/TextField";
import InputFeild from "../../components/common/TextFeild";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import "../Assesment/assesment.css";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import { validationSchema } from "../../utils/validations/operationalOverview";
import CircularProgress from "@mui/material/CircularProgress";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'


export default function OperationalOverview({
  formData,
  handlePreviousPage,
  previouscallingBackend,
  setPreviousCallingBackend,
  handleNextPage,
  callingBackend,
  setCallingBackend,
}) {
  const { state } = useLocation();

  const [initialValues, setInitialValues] = useState({
    number_of_employees: "",
    days_per_week: "",
    seasonality: "",
    description: "",
  });
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });
  const [quillbar, setQuillbar] = useState(
    formData?.operational_overview?.description
    || '');
  const toolbarOptions = [
    ["bold", "italic", "underline"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
  ];
  const module = {
    toolbar: toolbarOptions,
  };
  const submit = async (e, { resetForm }) => {
    try {
      setCallingBackend(true);
      await axios.put(`/assesment/operational-overview/${state.id}`, {
        number_of_employees: e.number_of_employees,
        days_per_week: e.days_per_week,
        description: quillbar,
        seasonality: e.seasonality,
      });
      setAlert({
        showAlert: true,
        severity: "success",
        message: "Operational Overview created successfully!",
      });
      setTimeout(
        () =>
          setAlert({
            showAlert: false,
            severity: "success",
            message: "Operational Overview created successfully!",
          }),
        handleNextPage(),
        5000
      );
    } catch (error) {
      if (error.response.data === "Operational Overview already exists") {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Operational Overview already exists!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Operational Overview already exists!",
            }),
          5000
        );
      } else if (error.response.status === 401) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Unauthorized Access!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Unauthorized Access!",
            }),
          5000
        );
      } else if (error.response.status === 500) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Server Error!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Server Error!",
            }),
          5000
        );
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Operational Overview already exists!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Operational Overview already exists!",
            }),
          5000
        );
      }
    }
  };

  useEffect(() => {
    setInitialValues({
      number_of_employees: formData?.operational_overview?.number_of_employees,
      days_per_week: formData?.operational_overview?.days_per_week,
      seasonality: formData?.operational_overview?.seasonality,
      description: formData?.operational_overview?.description,
    });
    setQuillbar(formData?.operational_overview?.description);
  }, [formData]);
  const handleClick = () => {
    setPreviousCallingBackend(true);
    handlePreviousPage();
  };
  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={submit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ dirty, isValid }) => {
          return (
            <Form>
              <Grid
                container
                xs={12}
                sx={{
                  padding: "1rem",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p className="formName">Operational Overview</p>
                <Grid container xs={10} spacing={1}>
                  <Grid item xs={12}>
                    <p className="inputTextH">Operational Activity</p>
                  </Grid>
                  <Grid item xs={12}>
                    <p className="inputTextP">Number Of Employees And Major Positions</p>
                    <InputFeild
                      name="number_of_employees"
                      component={TextField}
                      variant
                      fullWidth
                      bgColor="#FFFFFF"
                      margin="dense"
                      multiline
                      rows={3} // set initial rows to 3
                      maxRows={3} // set max rows to 4
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <p className="inputTextP">Days Per Week</p>
                    <InputFeild
                      name="days_per_week"
                      component={TextField}
                      variant
                      fullWidth
                      bgColor="#FFFFFF"
                      margin="dense"
                      multiline
                      rows={3}
                      maxRows={3}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <p className="inputTextP">Business Seasonality</p>
                    <InputFeild
                      name="seasonality"
                      component={TextField}
                      variant
                      fullWidth
                      bgColor="#FFFFFF"
                      margin="dense"
                      multiline
                      rows={3}
                      maxRows={3}
                    />
                  </Grid>
                  <Grid item xs={12} marginTop={"3rem"}>
                    <p className="inputTextH">Description</p>
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: "50px" }}>
                    <ReactQuill
                      modules={module}
                      theme="snow"
                      value={quillbar}
                      style={{ marginBottom: "25px", height: "300px" }} // Increased height
                      onChange={setQuillbar}
                    />
                  </Grid>
                  <Grid item xs={12} spacing={1}>
                    <div styles={{ whiteSpace: "pre-wrap" }}>
                      {JSON.stringify(quillbar, null, 2)}
                    </div>
                  </Grid>
                  <Grid
                    container
                    item
                    xs={12}
                    sx={{
                      alignContent: "center",
                      justifyContent: "space-between",
                      marginTop: "2rem",
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={() => handleClick()}
                      sx={{
                        backgroundColor: "#22345B",
                        textTransform: "capitalize",
                        fontFamily: "serif",
                        borderRadius: "8px",
                        ":hover": { backgroundColor: "#22345B" },
                      }}
                      disabled={previouscallingBackend}
                    >
                      {previouscallingBackend ? (
                        <CircularProgress
                          size={25}
                          sx={{ color: "#22345B", margin: "0 5px" }}
                        />
                      ) : (
                        "Previous"
                      )}
                    </Button>
                    <Button
                      variant="contained"
                      type="submit"
                      sx={{
                        backgroundColor: "#22345B",
                        textTransform: "capitalize",
                        fontFamily: "serif",
                        borderRadius: "8px",
                        ":hover": { backgroundColor: "#22345B" },
                      }}
                      disabled={callingBackend || !isValid || !quillbar}
                    >
                      {callingBackend ? (
                        <CircularProgress
                          size={25}
                          sx={{ color: "#22345B", margin: "0 5px" }}
                        />
                      ) : (
                        "Next"
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}